import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-24" data-testid="page-not-found">
      <Helmet>
        <title>Page not found — Manufacturing and Trading Services</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <p className="text-sm uppercase tracking-widest text-neutral-400 mb-3">404</p>
      <h1 className="text-3xl sm:text-4xl font-semibold text-neutral-900 mb-4">Page not found</h1>
      <p className="text-neutral-600 mb-8">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <div className="flex gap-6">
        <Link to="/" className="text-neutral-900 underline underline-offset-4 hover:text-neutral-600" data-testid="notfound-home-link">Home</Link>
        <Link to="/blog" className="text-neutral-900 underline underline-offset-4 hover:text-neutral-600" data-testid="notfound-blog-link">Blog</Link>
        <Link to="/services" className="text-neutral-900 underline underline-offset-4 hover:text-neutral-600" data-testid="notfound-services-link">Services</Link>
      </div>
    </main>
  );
}
